// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"4d1b9b27","468":"0407ef49","839":"ee93a1bf","885":"8925648b"}[chunkId] + ".css";
};